import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import * as onboarding from "./ducks/onboarding.duck";
import { metronic } from "../../_metronic";

export const rootReducer = combineReducers({
    auth: auth.reducer,
    onboarding: onboarding.reducer,
    builder: metronic.builder.reducer,
});

export function* rootSaga() {
    yield all([auth.saga()]);
}
